import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';

import {
  coursewareMetaInfoSetRequest,
  coursewareMetaInfoSetSuccess,
  coursewareMetaInfoSetError,
} from 'Workspace/Courseware/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { elementId, elementType, key, value } = action;

  yield put(coursewareMetaInfoSetRequest(elementId, key, value));
  const workspaceCoursewareMetaInfoSet = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_COURSEWARE_META_INFO_SET,
    elementId,
    elementType,
    key,
    value,
  });

  if (workspaceCoursewareMetaInfoSet.type === constants.RTM_WORKSPACE_COURSEWARE_META_INFO_SET_OK) {
    const coursewareElementMetaInformation = workspaceCoursewareMetaInfoSet.response.coursewareElementMetaInformation;
    const { value: responseValue } = coursewareElementMetaInformation;
    yield put(coursewareMetaInfoSetSuccess(elementId, key, responseValue));
  } else {
    yield put(coursewareMetaInfoSetError(elementId, key));
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage
        {...messages.failedWorkspaceCoursewareMetaInfoSet}
        values={{ key }}
      />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_COURSEWARE_META_INFO_SET, catchErrors, sendRequest, connection);
}
